export default __webpack_public_path__ + "static/media/Normas-Generales-Facturacion-y-Liquidación-Integracion.226f7bb8.pdf";